<template>
  <div class="user">
    
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click="toggleMenu" href="#">
         <span style="padding-left: 1em;"> 
           <i class="nc-icon nc-single-02" style="font-size: 1.5em; margin-right: 12px"></i>
           <span>{{ loggedUser }}</span>
           <b class="caret"></b>
         </span>
      </a>
      <!-- <Notifications /> -->
      <div class="clearfix"></div>
      <div>
        <div>
          <ul class="nav nav-menu" v-show="!isClosed">
            <li>
              <a href="#" @click="logoutUser">
                 <i class="nc-icon nc-minimal-right"></i>
               <!-- <span class="sidebar-mini-icon">L</span> -->
                <span class="sidebar-normal">{{ $t('usermenu.logout') }}</span>
              </a>
            </li>
            
            <li>
              <a data-toggle="collapse" href="#" @click="toggleLanguageMenu">
                <span style="padding-left: 0em;">
                  <i class="nc-icon nc-minimal-right"></i>
                  <span> {{$t('usermenu.language')}} </span>
                </span>
              </a>
               <collapse-transition>
                <ul class="nav nav-menu" v-show="showLanguages">
                  <li v-for="symbol in this.getLanguageList()" v-bind:key="symbol">
                    
                    <a class="language" @click="setLanguage(symbol)">
                      {{symbol.split("_")[0]}}
                    </a>
                    
                  </li>
                </ul>
               </collapse-transition>
            </li>

            <li>
              <a data-toggle="collapse" :aria-expanded="showPasswd" @click="togglePasswdMenu" href="#">
                <span style="padding-left: 0em;"> 
                  <i class="nc-icon nc-minimal-right"></i>
                  <span>{{ $t('usermenu.password') }}</span>
                </span>
              </a>
              <collapse-transition>
                <ul class="nav nav-menu" v-show="showPasswd">
                  <li>
                    <div class="password">
                    <fg-input v-model="password" 
                      :label="$t('users.password')"
                      v-validate="'required|min:passwordMinLength'" 
                      name="password" 
                      type="password" 
                      ref="password">
                    </fg-input>
                    <fg-input v-model="passwordConfirmation" 
                      v-validate="'required|confirmed:password'" 
                      name="passwordConfirmation" 
                      type="password" 
                      data-vv-as="password"
                      :label="$t('users.password_confirmation')">
                    </fg-input>
                  </div>
                  <div class="password alert alert-danger" v-if="showErrors && (errors.has('password') || errors.has('passwordConfirmation') || !passwordOk)">
                    {{ errorMsg }}
                  </div>
                  <div class="password">
                    <FormButtons @submit="submit" :reset="false" :remove="false" :disableSubmit="!passwordOk" />
                  </div>                  
                  <RequestInfo :type="infoType" :ok="ok" :error="error" :loader="loading" />
                  </li>
                </ul>
              </collapse-transition>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { CollapseTransition } from 'vue2-transitions'

// import Notifications from '@/components/Dispatching/Notifications'

  //import {createUserNavigation} from '../../TravellerNavigation'

  export default {
    components: {
      CollapseTransition /*,Notifications */
    },
    props: {
        passwordMinLength: { default: 6 }
    },
    data() {
      return {
        isClosed: true,
        showPasswd: false,
        showLanguages: false,
        password: null,
        passwordConfirmation: null,
        passwordOk: false,
        ok: false,
        error: false,
        loading: false,
        infoType: "save",
        errorMsg: "",
        showErrors: false        
      }
    },
    watch: {
        password() {
            this.checkPasswords();
        },
        passwordConfirmation() {
            this.checkPasswords();
        }
    },
    methods: {
      toggleMenu() {
        this.isClosed = !this.isClosed
      },
      togglePasswdMenu() {
        this.showPasswd = !this.showPasswd;
      },
      toggleLanguageMenu(){
        this.showLanguages = !this.showLanguages;
      },
      logoutUser: function() {
        this.$store.commit('logout');
        this.$router.push('/login');
        //this.$router.push({ path: '/login', query: { logout: 'true' }});
      },
      setLanguage(symbol) {
        //this.$i18n.locale = this.$i18n.locale == "en_EN" ? "fi_FI" : "en_EN";
        /*
        var nav = createUserNavigation();
        console.log(nav.length);
        */

        //this.$store.commit('setLocale', locale);
        this.$store.dispatch('setLocale', symbol);  
      },
      getLanguageList() {
        var languages = ["en_EN", "fi_FI", "pl_PL", "es_ES"];
        var current = this.$store.getters.currentLocale;
        return languages.filter( symbol => symbol != current);
      },
      checkPasswords() {
        this.passwordOk = (!this.passwordConfirmation && !this.password) 
            || (this.password === this.passwordConfirmation && this.password.length >= this.passwordMinLength);
        
        if (!this.passwordOk) {
            this.showErrors = true;
            this.errorMsg = this.password && this.password.length < this.passwordMinLength ? 
                this.$t('users.password_too_short') : 
                (!this.passwordOk ? this.$t('users.password_mismatch') : "");            
        } else
            this.showErrors = false;

        },
        submit() {
            this.ok = this.error = false;
            this.infoType = "save";
            this.loading = true;

            setTimeout(() => { 
                this.$store.dispatch('userDataHandler/savePassword' , this.password).then(response => {
                    this.ok = response.data.errorCode == 0;
                    this.error = !this.ok;
                })
                .catch( () => { 
                    this.error = true; 
                }) 
                .finally(() => {
                    this.loading = false;
                    this.passwordOk = false;
                })
            }, 1000);
        },

    },
    computed: {
      loggedUser () {
        return this.$store.getters.loggedInUser;
      }
    }
  }
</script>
<style scoped>
  .nav.nav-menu {
    margin-top: 0;
  }
</style>
